import React from 'react';
import ContentLoader from 'react-content-loader';

const Card = () => {
  return (
    <div className="card">
      <ContentLoader viewBox="20 20 150 150">
        <rect x="40" y="30" rx="4" ry="4" width="250" height="10" />
        <rect x="40" y="60" rx="4" ry="4" width="300" height="10" />
      </ContentLoader>
    </div>
  );
};

export default Card;
